/*--------------------------------------------------------------------------------------------
Program     :  HolidayWrngDialog.js
Description :  Main program for Map and Track  to view HolidayWrngDialog
Date        :  18/07/2025 
Created By  :  Jelbin
---------------------------------------------------------------------------------------------
TicketNo        Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
18072025       -Jelbin     -  18/07/2025         Created
---------------------------------------------------------------------------------------------*/
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Stack, Tooltip, Typography, TextField, Box } from '@mui/material';
import { amber } from '@mui/material/colors';

const HolidayWrngDialog = ({ dlgHolidayWrng, handleHolidayWrngYes }) => {
    return (
        <Dialog
            open={dlgHolidayWrng}
            PaperProps={{
                sx: {
                    border: `2px solid ${amber[700]}`,
                    borderRadius: 2,
                    boxShadow: 6,
                    px: 2,
                    py: 1,
                     width: '400px' 
                }
            }}
        >
            <DialogTitle></DialogTitle>
            <DialogContent
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'text.primary'
                }}
            >
                <WarningAmberIcon sx={{ color: amber[700] }} />
                <Typography variant="body1" color="text.primary">
                    Some participants are absent today. Please check before proceeding.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleHolidayWrngYes} autoFocus>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HolidayWrngDialog;
